// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const PhoneLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M17.4 22C8.9 21.99 2.011 15.1 2 6.6A4.6 4.6 0 016.6 2c.258-.002.516.021.77.07.245.036.486.097.72.18a1 1 0 01.65.75l1.37 6a1 1 0 01-.26.92c-.13.14-.14.15-1.37.79a9.91 9.91 0 004.87 4.89c.65-1.24.66-1.25.8-1.38a1 1 0 01.92-.26l6 1.37a1 1 0 01.72.65c.084.237.148.482.19.73.04.251.06.505.06.76A4.6 4.6 0 0117.4 22zM6.6 4A2.61 2.61 0 004 6.6c.005 7.398 6 13.394 13.4 13.4a2.61 2.61 0 002.6-2.6v-.33L15.36 16l-.29.55c-.45.87-.78 1.5-1.62 1.16a11.85 11.85 0 01-7.18-7.21c-.36-.78.32-1.14 1.18-1.59L8 8.64 6.93 4H6.6z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const PhoneLineOffset: IconOffset = {
    vertical: 8,
    horizontal: 8,
};

export default React.memo(PhoneLine);
